module.exports = __webpack_public_path__ + "img/notepad.62f82286.png";